<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D6ws1r/tc-custom/9781526755513.jpg?1701476962230" alt="This image is the cover for the book Building a WWII Jeep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Building a WWII Jeep
      </h1>
      <p class="bookDescription body article font2">
        <b>“Will delight anyone who has ever labored joyously to trace a pesky electrical fault, put body putty on a dent, or install brake pads on an old car.” —<i>Booklist</i></b><br/><br/> The Jeep as we know it from World War II newsreels, big screen movies, and television shows such as <i>M.A.S.H.</i> or <i>The Rat Patrol</i> was the result of the US War Department’s requirement for a light command-reconnaissance car to meet the US Army’s needs under the threat of a looming European war. After only a few weeks of development, the Jeep would end up in all of the Allied armies of the world courtesy of Bantam, Willys, and Ford. Many of the Jeeps built during the war would go on to serve for over sixty years in various parts of the world in both military and civilian use.<br/><br/> This book is a basic illustrated guide to building a WWII Jeep using restored, rebuilt, and modern reproduction parts for those who have never done it before—just like the author. You’ll find a clear step-by-step process used to build a truly historical vehicle. With supplemental books and websites noted in this volume and some basic auto mechanical knowledge on your part, you should be able to have your own piece of Jeep history rolling in no time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Dunnage
      </h2>
      
      <p class="authorDescription body article">Sean is a military vehicle restorer and military model maker in addition to hauling massive construction equipment to worksites all across Ontario, Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Transportt
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?569f2ff2